function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.35,3.9l-.71-.71a.5.5,0,0,0-.71,0h0L5.79,10.34,3.07,7.61a.51.51,0,0,0-.71,0l-.71.71a.51.51,0,0,0,0,.71l3.78,3.78a.5.5,0,0,0,.71,0h0L14.35,4.6A.5.5,0,0,0,14.35,3.9Z",
  transform: "translate(-1.51 -3.04)"
});

function SvgIconPanelCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ons-svg-icon ",
    viewBox: "0 0 13 10",
    focusable: "false",
    fill: "#0f8243"
  }, props), _ref);
}

export default __webpack_public_path__ + "9d6d1e357ee73a93f923ebe03e858689.svg";
export { SvgIconPanelCheckbox as ReactComponent };